import styled from "styled-components";

export const TabNavigationContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 10px 0;
  background-color: #fffff;
  border-bottom: 1px solid #ddd;
`;

export const TabButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px; /* Spacing between icon and label */
  background: ${(props) => (props.isActive ? "#EFE9FE" : "#F6F7F9")};
  color: ${(props) => (props.isActive ? "#000" : "#000")};
  border: none;
  border-top: ${(props) => (props.isActive ? "4px solid #9B5AF8" : "none")};
  border-radius: 4px;
  padding: 8px 16px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: #efe9fe;
    color: ${(props) => (props.isActive ? "#9B5AF8" : "#666")};
  }

  span {
    font-size: 14px;
    font-weight: bold;
    color: ${(props) => (props.isActive ? "#9B5AF8" : "#666")};
    display: ${(props) =>
      props.isActive ? "inline" : "none"}; /* Hide label when not active */
  }

  svg {
    font-size: 22px;
    color: ${(props) => (props.isActive ? "#9B5AF8" : "#666")};
  }
`;
